export default __webpack_public_path__ + "static/media/ghumfirlogo.59539ec3.png";